export default __webpack_public_path__ + "static/media/KOD0063-min.d32ba913.webp";